import type { CSSProperties, ReactNode } from "react";

type RuntimeHeightAttributes = { style: CSSProperties };

type RuntimeHeightProps = {
  height?: number;
  minHeight?: number;
  maxHeight?: CSSProperties["maxHeight"];
  children: (attributes: RuntimeHeightAttributes) => ReactNode;
};

/** Applies heights calculated from live chart data without exposing a general style escape. */
export function RuntimeHeight({ height, minHeight, maxHeight, children }: RuntimeHeightProps): ReactNode {
  return children({ style: { height, minHeight, maxHeight } });
}
